// client/src/index.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// Contextes
import { AuthProvider } from './contexts/AuthContext';
import { GameProvider } from './contexts/GameContext';
import { WalletProvider } from './contexts/WalletContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
          <GameProvider>
          <WalletProvider>
            <App />
          </WalletProvider>
          </GameProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Si vous souhaitez que votre application fonctionne hors ligne et se charge plus rapidement,
// vous pouvez changer unregister() en register() ci-dessous.
// R51 (02/09) : SW DÉSACTIVÉ même en prod — il servait des bundles périmés
// (bug « fix invisible » pour l'utilisateur après déploiement). Une app de jeu
// en ligne n'a pas besoin d'offline ; le cache navigateur HTTP suffit.
if (false && process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  // Désactive et purge tout service worker résiduel chez les joueurs
  serviceWorkerRegistration.unregister();
}

// Si vous souhaitez mesurer les performances de votre application, transmettez une fonction
// pour logger les résultats (par exemple: reportWebVitals(console.log))
reportWebVitals();